var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type == 1
      ? _c("div", { staticClass: "process" }, [
          _c("div", { staticClass: "box" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/image/submit@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("提交订单")]),
            _vm._v(" "),
            _c("p", { staticClass: "mar-top-10" }, [
              _vm._v(_vm._s(_vm.createTime))
            ])
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _vm._m(6),
          _vm._v(" "),
          _vm._m(7)
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 2
      ? _c("div", { staticClass: "process" }, [
          _c("div", { staticClass: "box" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/image/submit@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("提交订单")]),
            _vm._v(" "),
            _c("p", { staticClass: "mar-top-10" }, [
              _vm._v(_vm._s(_vm.createTime))
            ])
          ]),
          _vm._v(" "),
          _vm._m(8),
          _vm._v(" "),
          _vm._m(9),
          _vm._v(" "),
          _vm._m(10),
          _vm._v(" "),
          _vm._m(11),
          _vm._v(" "),
          _vm._m(12),
          _vm._v(" "),
          _vm._m(13),
          _vm._v(" "),
          _vm._m(14),
          _vm._v(" "),
          _vm._m(15)
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 3
      ? _c("div", { staticClass: "process" }, [
          _c("div", { staticClass: "box" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/image/submit@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("提交订单")]),
            _vm._v(" "),
            _c("p", { staticClass: "mar-top-10" }, [
              _vm._v(_vm._s(_vm.createTime))
            ])
          ]),
          _vm._v(" "),
          _vm._m(16),
          _vm._v(" "),
          _vm._m(17),
          _vm._v(" "),
          _vm._m(18),
          _vm._v(" "),
          _vm._m(19),
          _vm._v(" "),
          _vm._m(20),
          _vm._v(" "),
          _vm._m(21),
          _vm._v(" "),
          _vm._m(22),
          _vm._v(" "),
          _vm._m(23)
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 4
      ? _c("div", { staticClass: "process" }, [
          _c("div", { staticClass: "box" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/image/submit@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("提交订单")]),
            _vm._v(" "),
            _c("p", { staticClass: "mar-top-10" }, [
              _vm._v(_vm._s(_vm.createTime))
            ])
          ]),
          _vm._v(" "),
          _vm._m(24),
          _vm._v(" "),
          _vm._m(25),
          _vm._v(" "),
          _vm._m(26),
          _vm._v(" "),
          _vm._m(27),
          _vm._v(" "),
          _vm._m(28),
          _vm._v(" "),
          _vm._m(29),
          _vm._v(" "),
          _vm._m(30),
          _vm._v(" "),
          _c("div", { staticClass: "box" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/image/complete@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("完成")]),
            _vm._v(" "),
            _c("p", { staticClass: "mar-top-10" }, [
              _vm._v(_vm._s(_vm.receiveTime))
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 5
      ? _c("div", { staticClass: "process" }, [
          _c("div", { staticClass: "box" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/image/submit@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("提交订单")]),
            _vm._v(" "),
            _c("p", { staticClass: "mar-top-10" }, [
              _vm._v(_vm._s(_vm.createTime))
            ])
          ]),
          _vm._v(" "),
          _vm._m(31),
          _vm._v(" "),
          _vm._m(32),
          _vm._v(" "),
          _vm._m(33),
          _vm._v(" "),
          _vm._m(34),
          _vm._v(" "),
          _vm._m(35),
          _vm._v(" "),
          _vm._m(36),
          _vm._v(" "),
          _vm._m(37),
          _vm._v(" "),
          _vm._m(38)
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 6
      ? _c("div", { staticClass: "process" }, [
          _c("div", { staticClass: "box" }, [
            _c("img", {
              attrs: {
                src: require("../../../static/image/submit@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("提交订单")]),
            _vm._v(" "),
            _c("p", { staticClass: "mar-top-10" }, [
              _vm._v(_vm._s(_vm.createTime))
            ])
          ]),
          _vm._v(" "),
          _vm._m(39),
          _vm._v(" "),
          _vm._m(40),
          _vm._v(" "),
          _vm._m(41),
          _vm._v(" "),
          _vm._m(42),
          _vm._v(" "),
          _vm._m(43),
          _vm._v(" "),
          _vm._m(44),
          _vm._v(" "),
          _vm._m(45),
          _vm._v(" "),
          _vm._m(46)
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("p", { staticClass: "fs12 font-color-FF7 mar-bot-10" }, [
        _vm._v("等待付款")
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../static/image/xzdiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/pintuan@2x.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("拼团成功")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/chuku_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("商品出库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/transport_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("等待收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/complete_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/pintuanchengg@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("拼团成功")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("p", { staticClass: "fs12 font-color-FF7 mar-bot-10" }, [
        _vm._v("等待发货")
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../static/image/xzdiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/chuku_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("商品出库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/transport_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("等待收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/complete_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/pintuanchengg@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("拼团成功")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/delivery@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("商品出库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/transport_orange@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("等待收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/complete_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/pintuanchengg@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("拼团成功")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/delivery@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("商品出库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/transport@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("等待收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/pingtuanshibai@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "font-color-red" }, [_vm._v("拼团失败")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/chuku_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("商品出库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/transport_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("等待收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/complete_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("完成")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("p", { staticClass: "fs12 font-color-FF7 mar-bot-10" }, [
        _vm._v("等待成团")
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../static/image/xzdiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/pintuan@2x.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("拼团成功")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/chuku_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("商品出库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/transport_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("等待收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/complete_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("完成")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1656a843", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1656a843","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/status/statusSix.vue
// module id = null
// module chunks = 